import { IDeleteControleEstoqueUseCase } from "../../../presentation/useCases/delete/delete_controle_estoque_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class DeleteControleEstoqueUseCase implements IDeleteControleEstoqueUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async deleteControleEstoque(IdControleEstoque: number): Promise<void> {
    
    await this.repository.deleteControleEstoque(IdControleEstoque);
  }
}
